// Nextra theme config

export default {
  logo: <span>Ravioli</span>,
  project: { link: null },
  docsRepositoryBase: 'https://github.com/ch-apptitude/ch_apptitude_lingua_frontend/tree/master',

  // ... other theme options
};
